import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationComponent } from './core/authentication/authentication.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { AuthGuardService } from './core/Guards/auth-guard.service';
import { TeamsComponent } from './components/teams/teams.component';
import { CreateTeamComponent } from './components/create-team/create-team.component';
import { SpAssessmentsComponent } from './components/sp-assessments/sp-assessments.component';
import { ChangePasswordComponent } from './core/change-password/change-password.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: AuthenticationComponent },
  { path: 'login/:token', component: AuthenticationComponent },
  { path: 'home', component: HomePageComponent, canActivate: [AuthGuardService] },
  { path: 'home/:id', component: HomePageComponent, canActivate: [AuthGuardService] },
  { path: 'teams', component: TeamsComponent, canActivate: [AuthGuardService] },
  {
    path: 'add-team', component: CreateTeamComponent, canActivate: [AuthGuardService]
  },
  {
    path: 'add-team/:teamId', component: CreateTeamComponent, canActivate: [AuthGuardService]
  },
  {
    path: 'assessments', component: SpAssessmentsComponent, canActivate: [AuthGuardService]
  },
  { path: 'reset-password', component: ChangePasswordComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  {
    path: 'projects',
    loadChildren: () => import('../app/modules/projects/projects.module').then(m => m.ProjectsModule), canActivate: [AuthGuardService]
  },
  {
    path: 'workshop',
    loadChildren: () => import('src/app/modules/workshop/workshop.module').then(m => m.WorkshopModule), canActivate: [AuthGuardService]
  },
  {
    path: 'reports',
    loadChildren: () => import('../app/modules/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'metrics',
    loadChildren: () => import('../app/modules/metrics/metrics.module').then(m => m.MetricsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: '**', pathMatch: 'full', redirectTo: '/teams'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true }),
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
